import React from 'react';

import Screen, {backButton} from 'editor/screens/Screen';
import {COPY} from 'text/errors';

/** A project that lists no map pack the editor can read (EDI C5), where the legacy open loop never ended. */
export default function NoMapPacks() {
    const copy = COPY.screens.noMapPacks;

    return <Screen title={copy.title} body={[copy.body]} buttons={[backButton]}/>;
}
